export default __webpack_public_path__ + "static/media/check.1ffa3462.svg";